module.exports = __webpack_public_path__ + "media/components/web/pages/static_pages/resources/not_found_image-bbcec5bb344adac23552e32275564985.svg";